<p-dialog [(visible)]="this.open"
		  [baseZIndex]="10000"
		  [modal]="true"
		  [closeOnEscape]="false"
		  [draggable]="false"
		  [keepInViewport]="true"
		  [resizable]="false"
		  [focusOnShow]="false"
		  [closable]="false"
		  [maskStyleClass]="'maskStyle'"
		  [style]="{width: '700px'}">
	<p-header>
		{{ titre }}
	</p-header>
	<p>{{ message }}</p>
</p-dialog>
